var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadCloud2Line = function SvgUploadCloud2Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10 10.44 3.182 3.181-1.06 1.061-1.372-1.37V17.5h-1.5v-4.19l-1.37 1.372-1.062-1.061zm0-7.94a5.25 5.25 0 0 1 5.216 4.646 4.125 4.125 0 0 1-.715 8.087v-1.51a2.624 2.624 0 1 0-.834-5.183 3.75 3.75 0 1 0-7.333 0 2.625 2.625 0 0 0-.969 5.16l.135.023v1.51a4.125 4.125 0 0 1-.715-8.088A5.25 5.25 0 0 1 10 2.5"
  })));
};
export default SvgUploadCloud2Line;